import { WorkerAvailability } from '../../../../../models/workerAvailability'
import { AssistanceStatus } from '../../../../../models/assistanceStatus'
import { Assistance } from '../../../../../models/assistance'

interface IWorkerAvailabilitySelectItem {
  availability: WorkerAvailability
  enabled?: boolean
  status?: AssistanceStatus
  flags?: WorkerAvailabilitySelectItemFlag[]
}

export enum WorkerAvailabilitySelectItemFlag {
  IsExchangeAssistance,
}

export class WorkerAvailabilitySelectItem implements IWorkerAvailabilitySelectItem {
  availability: WorkerAvailability
  enabled = true
  status: AssistanceStatus
  flags: WorkerAvailabilitySelectItemFlag[]
  assistanceBefore: Assistance
  assistanceBeforeHHMM: string
  assistanceAfter: Assistance
  assistanceAfterHHMM: string

  constructor(props: IWorkerAvailabilitySelectItem) {
    this.availability = props.availability
    this.enabled = props.enabled
    this.status = props.status
    this.flags = props.flags
  }
}
